export default __webpack_public_path__ + "static/media/milestone 3000.d47b0db8.svg";